export default "__VITE_ASSET__IG3Y3yx8__"